import { Component } from 'react';
import { connect } from 'react-redux';
import { getDefaultType, getDisplayName, getIsModuleEditable } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { BaseResponsiveHeaderToolbar, buildHeaderActions } from './BaseResponsiveHeaderToolbar';
import { getIsInNonDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { DEFAULT_RESPONSIVE_SIZE } from 'layout-dnd-components/DndToolbar/constants';
import { getSelectedItemId } from 'ContentEditorUI/redux/selectors/selectionSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
const mapStateToProps = (state, ownProps) => {
  let newProps = {};
  if (ownProps.id) {
    newProps = {
      moduleType: getDefaultType(state, ownProps.id),
      displayName: getDisplayName(state, ownProps.id),
      isEditable: getIsModuleEditable(state, ownProps.id),
      selectedItemId: getSelectedItemId(state)
    };
  }
  newProps.isInNonDefaultBreakpointMode = getIsInNonDefaultBreakpointMode(state);
  return newProps;
};
class ResponsiveHeaderToolbar extends Component {
  render() {
    const {
      id,
      displayName,
      moduleType,
      top,
      left,
      onDropdownOpenChange,
      responsiveSize = DEFAULT_RESPONSIVE_SIZE,
      dispatch,
      bus,
      isEditable,
      isInNonDefaultBreakpointMode
    } = this.props;
    return /*#__PURE__*/_jsx(BaseResponsiveHeaderToolbar, {
      actions: buildHeaderActions({
        moduleId: id,
        moduleType,
        isInNonDefaultBreakpointMode,
        dispatch,
        bus,
        isEditable: !!isEditable
      }),
      onDropdownOpenChange: onDropdownOpenChange,
      insetBlockStart: `${Math.round(top)}px`,
      insetInlineStart: `${Math.round(left)}px`,
      position: "absolute",
      responsiveSize: responsiveSize,
      handleTooltip: displayName,
      iconUse: "pinned"
    });
  }
}
const mapDispatchToProps = dispatch => ({
  dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(ResponsiveHeaderToolbar);